const emptyObject = {};

export const getSearchMetadata = ({ search: { searchPassMeta } }) =>
  searchPassMeta || {};

export const selectSearchDiagnosticsDomain = state => ({
  diagnostics: state.search?.diagnostics ?? emptyObject,
  searchPassMeta: state.search?.searchPassMeta ?? emptyObject
});

export const getRequestId = state => state.search?.diagnostics?.requestId;

export const getRecommendationsAnalytics = state =>
  state.search?.diagnostics?.recommendationsAnalytics;

export const getAdvertisementsAnalytics = state =>
  state.search?.diagnostics?.advertisementsAnalytics;
